// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vSuk","inner":"Footer_inner__14Psr"};